<template>
<StyleProductDefault
    v-if="item && company" class="product-default"
    :class="[
        !related && layout_mode === 'grid' ? 'text-center '+(!class_responsive_when_side_menu ? (!$root.$children[0].theme.products.responsive_images_class ? 'col-6 col-sm-4 col-md-3 col-lg-2' : $root.$children[0].theme.products.responsive_images_class) : class_responsive_when_side_menu) : null,
        layout_mode == 'list' ? `${carousel_products == true ? '' : 'col-6'} col-sm-12 left-details ${carousel_products == true ? '' : 'product-list'} mb-4` : null,
        related ? ' left-details product-widget' : null,
        activeProductBoxShadowHover && 'product-hover-shadow'
    ]"
>
    <figure>
        <a
            v-if="!related && !page_wish_list && company.finalizacao_pagamento.tipo == 'PAGAMENTO'"
            href="#"
            class="btn-heart checked"
            @click.prevent.stop="saveWishList(item.wish)"
            aria-label="Adicionar a lista de desejos"
        >
            <c-wish-list v-if="activeIconWishlist"
                :class="[item.wish ? 'fas' : 'far', ' fa-heart']"
                :isFavorite="item.wish"
                :showShadow="showShadowIconWishlist"
                :activeIconWishlist="activeIconWishlist"
            ></c-wish-list>
        </a>
        <a
            @click.prevent="openProductModal == false ? productPage() : modalProduct()" :href="item.url_pro"
            :style="`${apply_height_img == true ? 'display: flex; justify-content: center;' : ''}`"
            @pointerenter="hoverImagesStart"
            @pointerleave="hoverImagesEnd"
        >
            <picture>
                <source
                    v-if="image_srcset"
                    type="image/webp"
                    :srcset="image_srcset"
                    :sizes="image_sizes"
                >
                <img
                    ref="image"
                    :src="current_image"
                    :alt="item.pro_name_site"
                    :loading="priority ? 'eager' : 'lazy'"
                    :fetchpriority="priority ? 'high' : 'auto'"
                    :style="`
                        position: relative; opacity: 1;
                        ${apply_height_img == true ?
                            'height:' + (!related ? image_height + 'px' : 'auto; width: 84px') + '; object-fit: '+ object_fit_img +';' : ''}
                        ${hover_lock_height ? 'height: ' + hover_lock_height + 'px; object-fit: contain;' : ''}
                        `"
                >
            </picture>
        </a>

        <status-product>
            <product-status-discount
                v-if="showDiscountStatus && item.percentage_discount > 0"
                class="product-label"
            >{{(getPercentageDiscountString(item.percentage_discount))}}% off</product-status-discount>
            <product-status-new
                v-if="item.pro_new_product && !session_news"
                class="product-label"
            >Novo</product-status-new>
            <product-status-sale
                v-if="item.pro_sale && !item.price_to"
                class="product-label"
            >Promoção</product-status-sale>
        </status-product>
    </figure>
    <div class="product-details" :style="`padding: ${search == true ? '0 10px 0 10px' : '0'};`">
        <div v-if="!related && !page_wish_list" class="category-list">
            <a href="#" class="product-category" :aria-label="'Categoria '+item.cat_name">
                {{item.cat_name}}
            </a>
        </div>

            <product-title-def :class="['product-title ', related || page_wish_list ? 'align-title-list' : 'align-title']">
            <a @click.prevent="openProductModal == false ? productPage() : modalProduct()" :href="item.url_pro">
                <template v-if="showCodeOriginal">{{ item.api_cod_original }} - </template>
                {{ product_name_site }}
            </a>
            </product-title-def>



        <strong v-if="activeBrandName">
           Marca: {{item.brand_name}}
        </strong>

        <Rating v-if="showRatings" :item="item" :layoutLeft="related || page_wish_list"/>
        <p
            v-if="layout_mode == 'list' && !related && !page_wish_list"
            class="product-description"
        >
            {{item.pro_desc_min}}
        </p>
        <product-price-box :class="['price-box', related || page_wish_list ? 'align-price-box-left' : 'align-price-box']">
            <Fragment
                v-if="
                    !item.price_on_request &&
                    ((((item.pro_stock_site > 0 && item.minimum_sale_quantity <= item.pro_stock_site) || item.sell_out_of_stock == true) &&
                    company.finalizacao_pagamento.tipo == 'PAGAMENTO') ||
                    (company.finalizacao_pagamento.mostrar_preco && company.finalizacao_pagamento.tipo == 'ORCAMENTO'))
                "
            >
                <template v-if="hidePrice == false">
                    <div class="product-pricing-content">
                        <span class="from-price" v-if="item.product_type_id == TYPE_VARIATION && !validateProductGroup">A partir de</span>
                        <span
                            v-if="( item.price_to || (
                                    item.from_price_site && item.pro_price_site && item.pro_price_site > item.from_price_site
                                    && +item.pro_price_site != +item.from_price_site )
                                )"
                            class="old-price"
                        >
                            {{currency.money(item.pro_price_site || item.from_price_site)}}
                        </span>
                        <product-price class="product-price">
                            {{ !item.price_to ? currency.money(item.from_price_site || item.pro_price_site ) : currency.money(item.price_to) }}
                            <small v-if="getShowUnitOfMeasureInProductPrice" style="font-size: 60%">
                                {{ item.pro_sigla_medida }}
                            </small>
                        </product-price>
                        <DiscountPix :product="item" />
                        <InterestFreeInstallments
                            :item="item"
                            :related="related"
                            :page_wish_list="page_wish_list"
                        />
                    </div>
                </template>
                <span
                    v-if="item.free_shipping && company.finalizacao_pagamento.tipo == 'PAGAMENTO'"
                    class="product-label"
                >
                    Frete grátis
                </span>
            </Fragment>
            <span
                class="product-unavailable"
                v-if="
                    (item.pro_stock_site <= 0 || item.minimum_sale_quantity > item.pro_stock_site) &&
                    item.out_of_stock_unavailable &&
                    item.sell_out_of_stock == false &&
                    !item.price_on_request &&
                    company.finalizacao_pagamento.tipo == 'PAGAMENTO'
                "
            >
                produto <strong>indisponível</strong>
            </span>
            <div v-if="!showProductActions()">
                <a @click.prevent="openProductModal == false ? productPage() : modalProduct()" :href="item.url_pro" style="display: flex; white-space: normal; justify-content: center;">
                    <span class="text-variation"
                        v-if="item.product_type_id == TYPE_VARIATION && !validateProductGroup">
                            Clique aqui para ver a linha completa
                    </span>
                </a>
            </div>

        </product-price-box>
        <!-- ACTIONS -->
        <product-action :class="['product-action', related || page_wish_list ? 'align-actions-left' : 'align-actions']">
            <div
                v-if="canQuickPurchase"
                :class="['quick-purchase', related || page_wish_list ? 'quick-purchase-left' : '']"
            >
                <c-input-qtd
                    class="input-quantity quick-purchase-quantity"
                    :style="{ '--quick-purchase-border-color': $root.$children[0].theme.products.button.border_color }"
                >
                    <button
                        class="btn-quantity-minus"
                        @click.prevent.stop="setQuickQuantityMinus()"
                        aria-label="Diminuir quantidade"
                    >
                        <i class="fas fa-minus"></i>
                    </button>
                    <label>
                        <input
                            type="text"
                            :value="quickQuantity"
                            @click.stop
                            @blur="setQuickQuantityByInput($event.target.value)"
                        >
                    </label>
                    <button
                        class="btn-quantity-plus"
                        @click.prevent.stop="setQuickQuantityPlus()"
                        aria-label="Aumentar quantidade"
                    >
                        <i class="fas fa-plus"></i>
                    </button>
                </c-input-qtd>
                <c-button
                    class="quick-purchase-button"
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    :fontSizeCart="$root.$children[0].theme.products.button.font_size_cart"
                    :disabled="isQuickPurchaseLoading"
                    @click.prevent.stop="quickPurchase()"
                    height="37px"
                    lineHeight="35px"
                    margin="0"
                    padding="0 2.4rem"
                    aria-label="Comprar produto"
                >
                    {{ isQuickPurchaseLoading ? 'Aguarde...' : quickPurchaseButtonText }}
                </c-button>
            </div>
            <c-button
                :backgroundColor="$root.$children[0].theme.products.view_button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.view_button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.view_button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :textTransform="$root.$children[0].theme.products.button.text_transform"
                v-if="showProductActions() && active_only_btn_buy == false"
                @click.stop="productPage()"
                margin="1px"
                :padding="padding_button"
                :class="`${active_icon_visualizar == true ? 'icon-eye' : ''}`"
                aria-label="Ir para a página do produto"
            >
                {{ $root.$children[0].theme.products.button.content_button }}
            </c-button>
            <c-button
                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :textTransform="$root.$children[0].theme.products.button.text_transform"
                :fontSizeCart="$root.$children[0].theme.products.button.font_size_cart"
                v-if="showProductActions() && !canQuickPurchase"
                @click.prevent="modalProduct()"
                margin="1px"
                :padding="padding_button_cart"
                aria-label="Abrir pop-up do produto"
            >
                <i v-if="active_only_btn_buy == false" style="line-height: 30px;" :class="cart_icon_class"></i>
                {{ textButtonOpenModal }}
            </c-button>
            <c-button
                v-if="showProductActions() && buttonWhatsapp && !item.price_on_request
                    && ((item.pro_stock_site > 0 && item.pro_stock_site >= item.minimum_sale_quantity)
                        || item.sell_out_of_stock)
                    && !(item.price_on_request && item.sell_out_of_stock)"
                backgroundColor="#fff"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button_whatsapp.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :textTransform="$root.$children[0].theme.products.button.text_transform"
                :fontSize="$root.$children[0].theme.products.button_whatsapp.font_size"
                :padding="$root.$children[0].theme.products.button_whatsapp.padding"
                :fontWeight="'500'"
                @click.prevent="consultaWhatsapp()"
                href="#"
                >
                <i title="Whatsapp" class="fab fa-whatsapp" style="font-size: 20px;"></i>
                Comprar pelo Whatsapp
            </c-button>
            <c-button
                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :textTransform="$root.$children[0].theme.products.button.text_transform"
                v-if="page_wish_list"
                display="flex"
                padding="0.2rem 1.8rem"
                @click.stop="removeItemWishList()"
                aria-label="Remover produto da lista de desejos"
            >
            <!-- padding_button -->
                <i class="fas fa-trash-alt"></i>
                Remover
            </c-button>
            <ProductTellMeWhenYouArrive
                v-if="
                    (item.pro_stock_site <= 0 || item.minimum_sale_quantity > item.pro_stock_site) &&
                    item.out_of_stock_unavailable &&
                    item.sell_out_of_stock == false &&
                    !item.price_on_request &&
                    company.finalizacao_pagamento.tipo == 'PAGAMENTO'
                "
                :item="item"
            />
        </product-action>
    </div>
</StyleProductDefault>
</template>

<script>
import { CButton } from '../Styles/Button/styled';
import {CAncora} from '../Styles/Button/styled'
import { CWishList } from '../Styles/WishList/styled';
import { CInputQtd } from '../Styles/Template/styled'
import Currency from '../../helpers/parseCurrency'
import { productImageSrcset } from '../../helpers/productImage'
import {mapActions, mapGetters, mapState } from 'vuex'
import {Fragment} from 'vue-fragment'
import InterestFreeInstallments from './InterestFreeInstallments.vue'
import DiscountPix from './DiscountPix.vue'
import Rating from './Rating.vue'
import {TYPE_PRODUCT, TYPE_VARIATION} from '../../services/product'
import { swall } from '../../services/sweetAlert'
import {
    CProductTitleDefault,
    CProductPrice,
    CProductStatusNew,
    CProductStatusDiscount,
    CProductStatusSale,
    CStatusProduct,
    CProductPriceBox,
    CProductAction,
    StyleProductDefault
} from '../Styles/Product/styled';
import ProductTellMeWhenYouArrive from './ProductTellMeWhenYoyArrive'

//tempo parado no card antes de trocar pela segunda foto
const HOVER_IMAGES_INTENT_MS = 150

export default {
    name: 'ProductDefault',
    components: {
        'c-button': CButton,
        'c-wish-list': CWishList,
        InterestFreeInstallments,
        DiscountPix,
        ProductTellMeWhenYouArrive,
        Fragment,
        StyleProductDefault,
        Rating,
        'c-ancora': CAncora,
        'product-title-def': CProductTitleDefault,
        'product-price': CProductPrice,
        'product-status-new': CProductStatusNew,
        'product-status-discount': CProductStatusDiscount,
        'product-status-sale': CProductStatusSale,
        'status-product': CStatusProduct,
        'product-price-box': CProductPriceBox,
        'product-action': CProductAction,
        'c-input-qtd': CInputQtd
    },
    props: {
        pro: {
            required: true
        },
        wishlist: {
            default: null
        },
        related: {
            default: false
        },
        //primeiro produto da listagem: candidato a LCP, nao pode ser adiado
        priority: {
            default: false
        },
        layout_mode: {
            default: 'grid',
            type: String
        },
        page_wish_list: {
            default: false
        },
        products_settings: {
            required: true
        },
        search: {
            default: false
        },
        class_responsive_when_side_menu: {
            type: String
        },
        session_news: {
            default: false
        },
        carousel_products: {
            default: false
        }
    },
    data() {
        return {
            currency: Currency,
            item: this.pro,
            image_height: this.products_settings?.altura_imagem ?? '450',
            apply_height_img: this.$root.$children[0].theme?.products?.apply_height_img ?? false,
            object_fit_img: this.$root.$children[0].theme?.products?.object_fit_img ?? 'cover',
            active_icon_visualizar: this.$root.$children[0].theme?.products?.button?.active_icon_visualizar ?? false,
            padding_button: this.$root.$children[0].theme?.products?.button?.padding ?? '0 1rem',
            padding_button_cart: this.$root.$children[0].theme?.products?.button?.padding_cart ?? '0 1rem',
            active_only_btn_buy: this.$root.$children[0].theme?.products?.button?.active_only_btn_buy ?? false,
            is_budget_layout: this.$root.$children[0].theme?.is_budget_layout ?? false,
            quickQuantity: Number(this.pro?.minimum_sale_quantity) > 0 ? Number(this.pro.minimum_sale_quantity) : 1,
            isQuickPurchaseLoading: false,
            //true enquanto a segunda foto esta no lugar da principal
            hover_active: false,
            hover_lock_height: null,
            TYPE_PRODUCT,
            TYPE_VARIATION
        }
    },
    created() {
        //fora do data: nao precisa ser reativo
        this.hover_timer = null
    },
    beforeDestroy() {
        clearTimeout(this.hover_timer)
    },
    methods: {
        ...mapActions("products", [
            "ActionSetItem",
            "ActionResetCarouselModal",
            "ActionGetProduct",
            "setConversionUnitWhenSellingWithClosedBox",
            "setAdditionalItems",
            "setResetItemsGrid",
            "setResetProduct",
            "setQuantity",
            "ActionResetAdditionalItems",
        ]),
        ...mapActions("tellMeWhenArrive", ["setProductTellMeWhenArrive"]),
        ...mapActions("clients", [
            "ActionSetEmailRegister"
        ]),
        ...mapActions("wishlist", [
            "ActionInsertItemWishList",
            "ActionRemoveItemWishList",
        ]),
        ...mapActions("cart", [
            "ActionSetItemCart",
            "ActionSetItemsCart"
        ]),
        async modalProduct() {
            this.setResetItemsGrid(true)
            setTimeout(() => {
                this.setResetItemsGrid(false)
            }, 100)
            this.$root.ajaxLoadingApp()
            localStorage.setItem('reset', 'true')
            // localStorage.setItem('reset_product_modal','true')
            jQuery('.product-single-carousel-quick-view').owlCarousel('destroy')
            await this.getProduct(this.item.id)
            if(this.facebookPixel?.settings?.ViewContent == true) {
                fbq('track', 'ViewContent')
            }
            if(typeof gtag === 'function') {
                gtag('event', 'view_item', {
                    'pageTitle': this.company.nome_fantasia,
                    'pageCategory': 'Produto',
                    'ecommerce': {
                        'currency': 'BRL',
                        'value': this.item.pro_price_site,
                        'products': [{
                            'id' : this.item.api_cod_original ?? '',
                            'name': this.item.pro_name_site,
                            'price': this.item.pro_price_site,
                            'category': this.item.cat_name
                        }],
                    }
                });
            }
            this.setConversionUnitWhenSellingWithClosedBox('UND')
            this.setAdditionalItems([])
            this.ActionResetAdditionalItems();
            this.setQuantity(this.minimumQuantity);
            this.setResetProduct(true);
            setTimeout(async () => {
                $('.quantity-linked-products-end-page').each(function() {
                    $(this).val(null)
                })
                await this.ActionResetCarouselModal('product-single-carousel-quick-view')
                await this.$root.ajaxLoadingRemoveApp()
                this.setResetProduct(false);
                this.$root.showModalApp('product_modal')
                document.getElementById('product_modal').style.overflow = 'auto'
            }, 100)
        },
        async getProduct(id) {
            await this.ActionGetProduct(id)
                .then(async (resp) => {
                    let {
                        data
                    } = resp
                    await this.ActionSetItem(data)
                    await this.setProductTellMeWhenArrive(data)
                })
                .catch((error) => {
                    swall(error?.msg ?? error)
                })
        },
        async productPage() {
            window.location = this.item.url_pro
        },
        showProductActions() {
            // if(
                // this.showButtonsProductActions &&
                // !this.related &&
                // !this.page_wish_list &&
                // (((
                //     (this.item.pro_stock_site > 0 && this.item.minimum_sale_quantity <= this.item.pro_stock_site) ||
                //     this.item.sell_out_of_stock == true
                // ) &&
                // this.company.finalizacao_pagamento.tipo == 'PAGAMENTO' || this.item.price_on_request) ||
                // (this.company.finalizacao_pagamento.tipo == 'ORCAMENTO'))
            // ) {
            //     return true
            // }return false
            return this.showProductPurchaseButtons && this.hasProductPurchaseAvailability;
        },
        async saveWishList(wish) {
            try {
                this.item.wish = !wish
                await this.ActionInsertItemWishList({
                    product_id: this.item.id
                })
                if(this.facebookPixel?.settings?.AddToWishlist == true && this.item.wish == true) {
                    fbq('track', 'AddToWishlist');
                }
                if(this.googleAds?.id != null) {
                    gtag('event', 'add_to_wishlist', {
                        'pageTitle': this.company.nome_fantasia,
                        'pageCategory': 'Produto',
                        'ecommerce' :{
                            'currency': 'BRL',
                            'value': this.item.pro_price_site,
                            'products': [{
                                'id' : this.item.api_cod_original,
                                'name': this.item.pro_name_site,
                                'price': this.item.pro_price_site,
                                'brand': this.item.brand_name ?? null,
                                'category': this.item.cat_name
                            }],
                        }
                    });
                }
            } catch (error) {
                this.item.wish = !this.item.wish
                if (error.status === 401) {
                    this.ActionSetEmailRegister(null)
                    this.$root.showModalApp('login_modal')
                    return
                }
                if (!error.data) {
                    swall(error)
                    return
                }
                let {
                    data = {}
                } = error.data
                if (data.msg) {
                    swall(msg)
                }
            }
        },
        async removeItemWishList() {
            await this.ActionRemoveItemWishList(this.item.id)
            // window.location.href = this.$baseUrl + 'wishlist/remove/' + this.item.id
            this.$emit('updateList')
            swall('Produto removido da lista de desejos com sucesso!', false, "check", "success", 3)
        },
        getPercentageDiscountString(percentage_discount) {
            if(percentage_discount.toString().includes('.')) {
                return parseFloat(percentage_discount).toFixed(2).toString().replace('.', ',')
            }
            return percentage_discount
        },
        consultaWhatsapp() {
            if(!this.textWhatsapp) {
                return
            }
            window.open(this.textWhatsapp, '_blank');
        },
        setQuickQuantityMinus() {
            this.quickQuantity = Math.max(this.minimumQuickQuantity, Number(this.quickQuantity) - 1)
        },
        setQuickQuantityPlus() {
            this.quickQuantity = Number(this.quickQuantity) + 1
        },
        setQuickQuantityByInput(quantity) {
            let parsedQuantity = parseInt(quantity, 10)
            if(!parsedQuantity || parsedQuantity < this.minimumQuickQuantity) {
                parsedQuantity = this.minimumQuickQuantity
            }
            this.quickQuantity = parsedQuantity
        },
        validateQuickPurchaseQuantity() {
            if(this.quickQuantity < this.minimumQuickQuantity) {
                swall(`A quantidade mínima é ${this.minimumQuickQuantity} ${this.item.pro_sigla_medida}!`)
                return false
            }

            if(!this.item.sell_out_of_stock) {
                let quantityInCart = 0
                if(this.itemsCart?.list?.length) {
                    let itemCart = this.itemsCart.list.find(el => el.id == this.item.id)
                    quantityInCart = Number(itemCart?.qtd_cart ?? 0)
                }

                if((Number(this.quickQuantity) + quantityInCart) > Number(this.item.pro_stock_site)) {
                    swall("Quantidade indisponível!")
                    return false
                }
            }

            return true
        },
        validateQuickPurchaseAmountByUser() {
            if(!this.client?.maximum_purchase_amount || this.client.maximum_purchase_amount <= 0) {
                return false
            }

            let priceMaxPurchase = Number(this.client.maximum_purchase_amount)
            let cartTotalAmount = Number(this.itemsCart?.totalAmount ?? 0)
            let productPrice = Number(this.item.price_to ?? this.item.pro_price_site ?? 0)
            let purchasePrice = (Number(this.quickQuantity) * productPrice) + cartTotalAmount

            if(purchasePrice == priceMaxPurchase) {
                return false
            }

            if(cartTotalAmount > priceMaxPurchase || purchasePrice > priceMaxPurchase) {
                let availableQuantity = (priceMaxPurchase - cartTotalAmount).toFixed(2)
                if(availableQuantity > 0) {
                    swall(`Seu limite restante é de ${this.currency.money(availableQuantity)} em compras!`)
                } else {
                    swall("Valor máximo de compra atingido!")
                }
                return true
            }
            return false
        },
        validateQuickPurchaseSupplier() {
            let cartSupplier = this.itemsCart?.list?.length ? this.itemsCart.list[0]?.supplier_name : null
            let supplierProduct = this.item?.supplier_name ?? (this.item?.suppliers?.length ? this.item.suppliers[0]?.supplier_name : null)

            if(this.itemsCart?.list?.length && cartSupplier && supplierProduct && supplierProduct != cartSupplier) {
                swall("Já existe outro fornecedor adicionado ao carrinho!")
                return true
            }
            return false
        },
        async quickPurchase() {
            if(this.isQuickPurchaseLoading) {
                return
            }

            if(!this.canQuickPurchase) {
                this.modalProduct()
                return
            }

            this.setQuickQuantityByInput(this.quickQuantity)
            if(!this.validateQuickPurchaseQuantity()) {
                return
            }
            if(this.validateQuickPurchaseAmountByUser()) {
                return
            }
            if(this.validateQuickPurchaseSupplier()) {
                return
            }

            this.isQuickPurchaseLoading = true
            let item = {
                pro_id: this.item.id,
                pro_qtd: this.quickQuantity,
                additionalItems: null,
                items_grid_id: null,
                flavors: [],
                fractional_quantity: null
            }

            await this.ActionSetItemCart(item)
                .then(async (resp) => {
                    let {data} = resp
                    this.ActionSetItemsCart(data)
                    if(this.facebookPixel?.settings?.AddToCart == true) {
                        await fbq('track', 'AddToCart', {content_type: 'product', contents: {id: item.pro_id, quantity: Number(item.pro_qtd)}})
                    }
                    if(typeof gtag === 'function') {
                        const findItem = resp.data.list.find(product => product.id == item.pro_id)
                        gtag('event', 'add_to_cart', {
                            'pageTitle': this.company.nome_fantasia,
                            'pageCategory': 'Produto',
                            'ecommerce' :{
                                'currency': 'BRL',
                                'value': ((findItem.price_to ?? findItem.pro_price_site) * Number(item.pro_qtd)).toFixed(2),
                                'products' : [{
                                    'id' : findItem.api_cod_original,
                                    'name': findItem.pro_name_site,
                                    'discount' : findItem.percentage_discount,
                                    'quantity' : Number(item.pro_qtd),
                                    'price': (findItem.price_to ?? findItem.pro_price_site).toFixed(2),
                                    'variant': findItem.items_grid_abbreviaton ?? (findItem.grid_group_column_value ?? '' + findItem.grid_group_row_value ?? '')
                                }],
                            }
                        });
                    }
                    swall('Produto adicionado ao carrinho com sucesso!', false, "check", "success")
                })
                .catch((error) => {
                    swall(error?.msg ?? error)
                })
                .finally(() => {
                    this.isQuickPurchaseLoading = false
                })
        },
        /**
         * Com o mouse sobre a imagem, mostra a segunda foto do produto. So
         * vale para mouse: no toque o primeiro tap trocaria a foto em vez de
         * abrir o produto.
         */
        hoverImagesStart(event) {
            if(!this.hover_images_enabled || event.pointerType !== 'mouse') {
                return
            }
            /**
             * So troca se o mouse parar no card. Quem passa o mouse pela
             * grade atravessaria dezenas de cards, e cada um pediria a segunda
             * foto — a que ainda nao tem w300 gerado vira um Imagick no FPM
             * do painel.
             */
            clearTimeout(this.hover_timer)
            this.hover_timer = setTimeout(this.hoverImagesActivate, HOVER_IMAGES_INTENT_MS)
        },
        hoverImagesActivate() {
            this.hover_timer = null
            //sem altura fixa no tema, a altura vem da proporcao da foto; uma
            //foto com outra proporcao faria o card (e a grade) pular
            if(!this.apply_height_img && this.$refs.image?.offsetHeight > 0) {
                this.hover_lock_height = this.$refs.image.offsetHeight
            }
            //o navegador segue mostrando a principal ate a segunda carregar,
            //entao nao precisa de preload
            this.hover_active = true
        },
        hoverImagesEnd() {
            clearTimeout(this.hover_timer)
            this.hover_timer = null
            this.hover_active = false
            this.hover_lock_height = null
        },
        parseConfigList(value) {
            if(!value) {
                return []
            }
            if(Array.isArray(value)) {
                return value
            }
            if(typeof value == 'string') {
                try {
                    return JSON.parse(value) ?? []
                } catch(e) {
                    return []
                }
            }
            return []
        },
    },
    watch: {
        itemWish(item) {
            if (!item || item == "") {
                return
            }
            if (item.id === this.item.id) {
                this.item.wish = item.wish
            }
        }
    },
    computed: {
        //null quando a imagem nao esta em products/: ai a <source> nem e emitida
        image_srcset() {
            return productImageSrcset(this.current_image)
        },
        current_image() {
            return this.hover_active ? this.hover_image : this.item.image_main
        },
        //ligado por loja em Layout > Produtos no painel
        hover_images_enabled() {
            return (this.$root.$children[0].theme?.products?.hover_images ?? false) === true
                && !this.related
                && !!this.hover_image
        },
        /**
         * Segunda foto do produto: entre as que nao sao a da listagem, a
         * marcada como principal (se houver) e depois a de menor id. A query
         * junta as fotos sem ORDER BY, entao a ordem que chega nao e estavel.
         */
        hover_image() {
            const second = this.parseConfigList(this.item?.images)
                .filter(image => image && image.url && image.url !== this.item.image_main)
                .sort((a, b) => ((b.main ? 1 : 0) - (a.main ? 1 : 0)) || ((a.id ?? 0) - (b.id ?? 0)))[0]

            return second ? second.url : null
        },
        /**
         * Com so tres larguras disponiveis, a escolha entre 300 e 600 acaba
         * sendo o DPR da tela, e nao o valor exato daqui — por isso um numero
         * unico da conta das grades de 3, 4, 5 e 6 colunas.
         *
         * Quando o tema fixa a altura da imagem e usa object-fit cover, a
         * imagem e esticada ate cobrir essa altura, entao a largura util passa
         * a ser a altura da caixa, nao a da coluna.
         */
        image_sizes() {
            if(this.related) {
                return '84px'
            }
            if(this.apply_height_img) {
                return `${this.image_height}px`
            }

            return '(max-width: 575px) 50vw, 220px'
        },
        ...mapState("products", [
            "itemWish",
            "conversionUnitWhenSellingWithClosedBox",
            "minimumQuantity"
        ]),
        ...mapState("company", [
            "company",
            "facebookPixel",
            "googleAds",
            "socials"
        ]),
        ...mapState("cart", [
            "itemsCart"
        ]),
        ...mapState("clients", [
            "client"
        ]),
        ...mapGetters('company', [
            "showRatings",
            "getShowUnitOfMeasureInProductPrice",
            "showCodeOriginalBesideDescription"
        ]),
        showCodeOriginal() {
            return (
                this.showCodeOriginalBesideDescription &&
                this.item.api_cod_original
            );
        },
        product_name_site() {
            let textTransform = this.$root.$children[0].theme?.products?.text_transform ?? ''

            return textTransform == 'uppercase' ? this.item.pro_name_site.toUpperCase() :
                textTransform == 'lowercase' ? this.item.pro_name_site.toLowerCase() :
                textTransform == 'initial' ? (this.item.pro_name_site.charAt(0).toUpperCase() + this.item.pro_name_site.toLowerCase().substr(1)) :
                textTransform == 'capitalize' ? (this.item.pro_name_site.toLowerCase().replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); })) : this.item.pro_name_site
        },
        hidePrice() {
            let hide = this.company?.settings?.hide_price_not_logged_user ?? false
            return ( hide === false ) ? false : ( hide === true && this.isLogged === false ? true : false )
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged
        },
        validateProductGroup() {
            return (this.activateSaleProductGroups && this.isProductGroup)
        },
        isProductGroup() {
            return this.productSettings?.is_product_group ?? false
        },
        productSettings(){
            if(this.item?.settings) {
                return JSON.parse(this.item.settings)
            }
            return null
        },
        activateSaleProductGroups() {
            return this.$root.$children[0].$attrs.company?.settings?.activate_sale_product_groups ?? false
        },
        isProductCustomization() {
            return this.productSettings?.is_product_customization ?? false
        },
        activateProductCustomization() {
            return this.$root.$children[0].$attrs.company?.settings?.activate_product_customization ?? false
        },
        atLeastOneAdditionalItemRequired() {
            return this.productSettings?.at_least_one_additional_item_required ?? false
        },
        textButtonOpenModal() {
            return (this.active_only_btn_buy == true ?
                (this.$root.$children[0].theme.products.button.content_button) : '')
        },
        showShadowIconWishlist() {
            return this.$root.$children[0].theme?.products?.icon_wishlist?.show_shadow ?? true
        },
        activeProductBoxShadowHover() {
            return (this.$root.$children[0].theme?.products?.box_shadow_hover?.active_box_shadow ?? false) && !this.related;
        },
        showProductPurchaseButtons() {
            return this.$root.$children[0].theme?.products?.button?.active_product_purchase_buttons ?? true;
        },
        hasProductPurchaseAvailability() {
            return (
                !this.related &&
                !this.page_wish_list &&
                (((
                    (this.item.pro_stock_site > 0 && this.item.minimum_sale_quantity <= this.item.pro_stock_site) ||
                    this.item.sell_out_of_stock == true
                ) &&
                this.company.finalizacao_pagamento.tipo == 'PAGAMENTO' || this.item.price_on_request) ||
                (this.company.finalizacao_pagamento.tipo == 'ORCAMENTO'))
            )
        },
        activeQuickPurchaseButton() {
            return this.$root.$children[0].theme?.products?.button?.active_quick_purchase_button ?? false
        },
        minimumQuickQuantity() {
            return Number(this.item?.minimum_sale_quantity) > 0 ? Number(this.item.minimum_sale_quantity) : 1
        },
        quickPurchaseButtonText() {
            return this.company.finalizacao_pagamento.tipo == 'PAGAMENTO' ? (this.is_budget_layout ? 'Orçar' : 'Comprar') : 'Orçamento'
        },
        hasItemsGrid() {
            return this.parseConfigList(this.item?.items_grid).length > 0
        },
        hasFlavors() {
            return this.parseConfigList(this.item?.flavors).length > 0
        },
        needsProductChoice() {
            return (
                (this.item.product_type_id == TYPE_VARIATION && !this.validateProductGroup) ||
                this.validateProductGroup ||
                this.item.is_linked_products ||
                this.item.fractional_sale ||
                this.hasItemsGrid ||
                this.hasFlavors ||
                this.atLeastOneAdditionalItemRequired ||
                (this.activateProductCustomization && this.isProductCustomization)
            )
        },
        canQuickPurchase() {
            return (
                this.activeQuickPurchaseButton &&
                this.hasProductPurchaseAvailability &&
                !this.item.price_on_request &&
                !this.needsProductChoice
            )
        },
        showDiscountStatus() {
            let status = this.$root.$children[0].theme?.products?.status
            return typeof status?.show_discount == 'boolean' ? status.show_discount : true
        },
        activeIconWishlist() {
            return this.$root.$children[0].theme?.products?.icon_wishlist?.active_icon_wishlist ?? true
        },
        activeBrandName() {
            return this.$root.$children[0].theme?.products?.active_brand_name ?? false
        },
        openProductModal() {
            return this.$root.$children[0].theme?.products?.open_product_modal ?? false
        },
        cart_icon_class() {
            return this.$root.$children[0].theme?.cart_icon_class ?? 'icon-cart'
        },
        buttonWhatsapp() {
            return this.$root.$children[0].theme?.products?.button_whatsapp?.active_button_whatsapp ?? false
        },
        textWhatsapp() {
            if(!this.socials[4]?.link) {
                return null
            }
            let text = "Olá, tenho interesse no produto "+this.item.pro_name_site+"."
            return this.socials[4].link+"&text="+text
        },
    },
}
</script>

<style scoped>
.quick-purchase {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    flex-wrap: nowrap;
    width: 100%;
    margin: 1px;
}

.quick-purchase-left {
    justify-content: flex-start;
}

.quick-purchase-quantity {
    margin: 0 !important;
}

.quick-purchase-quantity label {
    display: flex;
    margin: 0;
}

.quick-purchase-quantity button,
.quick-purchase-quantity input {
    border-color: var(--quick-purchase-border-color) !important;
    height: 37px !important;
}

.quick-purchase-quantity button:hover,
.quick-purchase-quantity button:focus {
    border-color: var(--quick-purchase-border-color) !important;
}

.quick-purchase-quantity button {
    width: 28px !important;
}

.quick-purchase-quantity input {
    width: 34px !important;
    text-align: center;
}

.quick-purchase-button {
    align-self: center;
}

.quick-purchase button[disabled] {
    cursor: wait;
    opacity: 0.75;
}

.shadow-wish {
    text-shadow: 2px 3px 8px #000;
}

/* .align-title {
    margin-left: 15px;
    margin-right: 15px;
} */

@media (max-width: 768px) {
    .align-title {
        margin-left: auto;
        margin-right: auto;
        white-space: nowrap;
    }

}
</style>
